export const RowStates = Object.freeze({
    Accent: 'accent',
    BorderVisible: 'borderVisible',
    Final: 'final',
    Regular: 'regular',
    Secondary: 'secondary',
    Subtotal: 'subtotal',
    Total: 'total'
});

export type RowState = (typeof RowStates)[keyof typeof RowStates];
